import RenProcessRunning from './src/ren-process-running'

RenProcessRunning.install = function (Vue) {
  Vue.component(RenProcessRunning.name, RenProcessRunning)
}

export default RenProcessRunning
